<div class="emperor-ui-naics-header">
  <mat-expansion-panel
    (opened)="panelOpenState.set(true)"
    (closed)="panelOpenState.set(false)"
    class="emperor-ui-explanation-panel mat-elevation-z0"
  >
    <mat-expansion-panel-header>
      <mat-panel-title class="emperor-ui-explanation-panel-title">
        <div class="emperor-ui-naics-heading">
          <span class="emperor-ui-naics-description">{{
            naicsDescription
          }}</span>
          <span class="emperor-ui-naics-code" *ngIf="naicsCode">
            - {{ naicsCode }}</span
          >
        </div>
        <div
          class="emperor-ui-explanation-toggle"
          [class.opened]="panelOpenState()"
        >
          {{ panelOpenState() ? 'Hide' : 'Show' }}
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p [innerHTML]="explanation"></p>
  </mat-expansion-panel>
  <span class="emperor-ui-naics-visual-divider"></span>
</div>
